import React, { Component } from "react";
import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';

export default class PageDataNumber extends Component {
  	
  	constructor(){
		super()
		this.state = {
			started:false,
			ended:false
		}
		this.startAnimation = this.startAnimation.bind(this);
		this.endAnimation 	= this.endAnimation.bind(this);
	}
	
	startAnimation = (isVisible) => {
		if (this.state.started === false && isVisible === true) {
			this.setState({started : true});
		}
    }
    
	endAnimation() {  
		if (this.state.ended === false) {
			this.setState({ended : true});
		}
    }
  	
	render () {
				
		let prepend = this.props.prepend;
		let data 	= this.props.data;
		let append 	= this.props.append;
				
		if (data) {

			let block = [];
			if (prepend) {
				block.push(prepend);
			}
			if (data) {
				if (this.state.started && this.state.ended) {
					block.push(data);
				} else if (this.state.started) {
					block.push(<CountUp start={0} end={data} duration={1} onEnd={this.endAnimation} startOnMount={true} />);
				} else {
					block.push('0');
				}
			}
			if (append) {
				block.push(append);
			}
		
		    return (
			   				
				<VisibilitySensor onChange={this.startAnimation}>
				
					<p className="c-data__number">{block}</p>
				
				</VisibilitySensor>
			    				
			)
			
		} else {
			
			return null;
		
		}
	}
}
